import { type ReactNode } from 'react';

import { designTokens } from '../theme/tokens';

type AlertTone = 'info' | 'success' | 'warning' | 'danger';

const toneColors: Record<AlertTone, string> = {
  info: designTokens.colors.surfaceTint,
  success: designTokens.colors.primaryContainer,
  warning: designTokens.colors.warning,
  danger: designTokens.colors.error,
};

export function Alert({ children, tone = 'info' }: { children: ReactNode; tone?: AlertTone }) {
  const color = toneColors[tone];
  return (
    <p
      aria-live={tone === 'danger' || tone === 'warning' ? 'assertive' : 'polite'}
      style={{
        background: 'rgba(2, 4, 3, 0.28)',
        border: `1px solid ${color}`,
        borderRadius: designTokens.radius.sm,
        color,
        margin: 0,
        padding: '8px 10px',
      }}
    >
      {children}
    </p>
  );
}
